var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useLocalStorage from '@madbox/use-local-storage';
import { PushPin } from '@mui/icons-material';
import { Grid, IconButton, styled } from '@mui/material';
var ActionsbarContainer = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'stickyActionBar'; },
})(function (_a) {
    var theme = _a.theme, stickyActionBar = _a.stickyActionBar;
    return ({
        position: stickyActionBar ? 'sticky' : undefined,
        backgroundColor: stickyActionBar ? theme.palette.background.default : undefined,
        overflow: 'hidden',
        top: stickyActionBar ? theme.spacing(-2) : undefined,
        marginTop: stickyActionBar ? theme.spacing(-2) : undefined,
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
        paddingTop: stickyActionBar ? theme.spacing(2) : undefined,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        zIndex: stickyActionBar ? 2000 : undefined,
    });
});
var FloatRight = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        float: 'right',
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(2),
    });
});
var FloatLeft = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        float: 'left',
        marginBottom: theme.spacing(2),
    });
});
var FloatClear = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({ clear: 'both' });
});
/**
 * Elements of this component will be displayed just under the header
 *
 * It should contain filters and action buttons.
 *
 * @example
 * <ActionsbarContent
 *   filters={[
 *     <Autocomplete
 *       options={['Un', 'Deux']}
 *       renderInput={(params) => <TextField {...params} placeholder="Autocomplete" />}
 *     />,
 *   ]}
 *   actions={[<Button>Create App</Button>]}
 * />
 *
 * @param props
 * @returns
 */
export var ActionsbarContent = function (props) {
    var _a = useLocalStorage('stickyFilters'), stickyActionBar = _a[0], setStickyActionBar = _a[1];
    var blocksFilters = props.filters && (Array.isArray(props.filters[0]) ? props.filters : [props.filters]);
    return blocksFilters || props.actions ? (_jsxs(_Fragment, { children: [_jsxs(ActionsbarContainer, __assign({ stickyActionBar: !!props.stickable && stickyActionBar === 'true', sx: props.sx, style: props.style }, { children: [props.actions && (_jsx(FloatRight, { children: _jsx(Grid, __assign({ container: true, alignItems: "center" }, { children: props.actions.map(function (action, i) { return (_jsx(Grid, __assign({ item: true }, { children: action }), i)); }) }), void 0) }, void 0)), blocksFilters && (_jsx(FloatLeft, { children: _jsx(Grid, __assign({ container: true }, { children: blocksFilters.map(function (filters, i) { return (_jsx(Grid, __assign({ item: true }, { children: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [props.stickable && i === 0 ? (_jsx(IconButton, __assign({ sx: function (theme) { return ({
                                                marginRight: 0,
                                                marginTop: theme.spacing(2),
                                                marginLeft: theme.spacing(2),
                                            }); }, disableRipple: true, onClick: function () { return setStickyActionBar(stickyActionBar === 'true' ? 'false' : 'true'); } }, { children: _jsx(PushPin, { fontSize: "small", color: stickyActionBar === 'true' ? 'primary' : 'disabled' }, void 0) }), void 0)) : null, filters.map(function (filter, j) { return (_jsx(Grid, __assign({ item: true }, { children: filter }), j)); })] }), void 0) }), i)); }) }), void 0) }, void 0))] }), void 0), _jsx(FloatClear, {}, void 0)] }, void 0)) : null;
};
